import api from '../api';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    setCard(store, params) {
      return api.post('/card/control', '渠道列表列表', params).then((res) => {
        return res.data;
      });
    },
  },
};
